import { render, staticRenderFns } from "./BtnDownloadMobile.vue?vue&type=template&id=4b122b4e&scoped=true&"
import script from "./BtnDownloadMobile.vue?vue&type=script&lang=js&"
export * from "./BtnDownloadMobile.vue?vue&type=script&lang=js&"
import style0 from "./BtnDownloadMobile.vue?vue&type=style&index=0&id=4b122b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b122b4e",
  null
  
)

export default component.exports